export enum PauseResumeAction {
  PAUSE,
  RESUME,
}

export namespace PauseResumeAction {
  let elements = [PauseResumeAction.PAUSE, PauseResumeAction.RESUME];
  let alias = "com.bcdfx.api.servicerequest.trading.PauseResumeAction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
